import { render, staticRenderFns } from "./WikiDomainAllowlist.vue?vue&type=template&id=33bf016c&scoped=true"
import script from "./WikiDomainAllowlist.vue?vue&type=script&lang=ts"
export * from "./WikiDomainAllowlist.vue?vue&type=script&lang=ts"
import style0 from "./WikiDomainAllowlist.vue?vue&type=style&index=0&id=33bf016c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf016c",
  null
  
)

export default component.exports